 
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'; 
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs'; 
import { CreateNewBeneficiaryComponent } from 'src/app/modules/beneficiary/create-new-beneficiary/create-new-beneficiary.component';

import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CreateBeneConnectionComponent } from 'src/app/modules/beneficiary/create-bene-connection/create-bene-connection.component';
import { CreateBeneAttorneyComponent } from 'src/app/modules/beneficiary/create-bene-attorney/create-bene-attorney.component';
import { AttorneyService } from 'src/app/services/attorney.service';
import { HelpVideoOverlayComponent } from '../../shared/help-video-overlay/help-video-overlay.component';

@Component({
  selector: 'app-beneficiary-invite',
  templateUrl: './beneficiary-invite.component.html',
  styleUrls: ['./beneficiary-invite.component.scss'],
  providers: [DialogService, MessageService]
})
export class BeneficiaryInviteComponent implements OnInit, OnDestroy {
  @ViewChild(HelpVideoOverlayComponent, { static: false }) helpVideoOverlayComponent: HelpVideoOverlayComponent;
  listOfClientCompanies: any;
  searchBeneficiary: string;
  showNoContent: boolean;
  beneficiaryDetails: any;
  observableSubscription$ = new Subject();
  userType:any;

  ref: DynamicDialogRef;
  searchResult = false;
  pageNumber: number;
  pageSize: number;
  totalRecords: number;

  constructor(
    private apiService: AttorneyService, 
    public dialogService: DialogService,
    public messageService: MessageService) {
    this.pageNumber = 1;
    this.pageSize = 25;
  }

  ngOnInit(): void {
    this.userType = sessionStorage.getItem('userTypeRole');
    this.beneficiaryDetails = [{}];
    setTimeout(() => {
      this.helpVideoOverlayComponent?.setTabValues(
        "right",
        "Petitioner Inviting Beneficiary",
        "Part 1: Petitioner Inviting Beneficiary",
        "Part 1: Petitioner Inviting Beneficiary",
        "right",
        "Part 2: Beneficiary accepting Invite from Petitioner",
        "Part 2: Beneficiary accepting Invite from Petitioner"
      );
    }, 2000)
  }
  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
  
  openFormModalCreate() {
    this.ref = this.dialogService.open(CreateNewBeneficiaryComponent, {
      header: this.userType == 'Beneficiary' ? 'Create Beneficiary': 'Create Employee',
      width: '70%',
      contentStyle: { 'max-height': '800px', overflow: 'auto' }
    });
  }

  sendInvite() {
    this.ref = this.dialogService.open(CreateBeneAttorneyComponent, {
      header: this.userType == 'Beneficiary' ? 'Invite Beneficiary': 'Invite Employee',
      width: '50%',
      contentStyle: { 'max-height': '500px', overflow: 'auto' }
    });
  }

  connectBene(beneDetails: any) {
    this.ref = this.dialogService.open(CreateBeneConnectionComponent, {
      header: 'Add New Beneficiary Connection',
      width: '30%',
      contentStyle: { 'max-height': '500px', overflow: 'auto' },
      data: { fname: beneDetails.fname, lname: beneDetails.lname, id: beneDetails.id }
    });
  }

  searchInput() {
    if (!this.searchBeneficiary || (this.searchBeneficiary && this.searchBeneficiary.length < 3)) {
      return;
    }
    this.apiService.getBenficiaryLists({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchText: this.searchBeneficiary
    })
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: []) => {
        this.beneficiaryDetails = response['beneficiaries'];
        this.searchResult = true;
        if (response['totalElementCount'] > 0) {
          this.totalRecords = response['totalElementCount'];
          this.showNoContent = false;
        } else {
          this.totalRecords = 0;
          this.showNoContent = true;
        }
      });
  }

  paginate(event) {
    this.pageNumber = event.page + 1;
    this.pageSize = event.rows;
    this.searchInput();
  }

}
